module.exports = __webpack_public_path__ + "img/camera.8e139458.png";